import React from 'react';
import styles from './styles.module.css';

function ProgressCircle({ progress, label, price }) {
  return (
    <div>
      {/* Progress Circle */}
      <div className={styles.circle}>
        {/* Progress Bar */}
        <div
          className={styles.progressBorder}
          style={{
            '--progress': progress,
          }}
        ></div>

        {/* Covered Percentage (White Text) */}
        <div
          className={styles.coveredText}
          style={{
            '--progress': progress,
          }}
        >
          {progress}%
        </div>

        {/* Remaining Percentage (Black Text) */}
        <div className={styles.remainingText}>{progress}%</div>
      </div>

      {/* Labels and Price */}
      <span className={styles.cardText}>{label}</span> {"   "}
      <span className={styles.cardText}>{price}</span>
    </div>
  );
}

export default function PaymentEarning({ left, right }) {
  return (
    <div className={styles.container}>
      <ProgressCircle
        progress={left.progress}
        label={left.label}
        price={left.price}
      />
      <ProgressCircle
        progress={right.progress}
        label={right.label}
        price={right.price}
      />
    </div>
  );
}
